var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.893 14.658c-.197.54-.71.93-1.319.93H3.407A1.409 1.409 0 0 1 2 14.181V5.737c0-.777.631-1.408 1.407-1.408h3.167c.608 0 1.122.39 1.318.93l.003-.001v9.4h-.002zm-2.167-2.813a.704.704 0 0 0-1.408 0v.928a.704.704 0 0 0 1.408 0v-.928zM20.554 14.794a2.08 2.08 0 0 1-1.642.794h-3.66l.726 1.903c.326.858.2 1.816-.337 2.565a2.804 2.804 0 0 1-2.396 1.16 1.573 1.573 0 0 1-1.32-.876l-1.852-3.646a4.305 4.305 0 0 0-.771-1.066V4.632a5.877 5.877 0 0 1 1.839-.303h6.05c.972 0 1.807.652 2.032 1.584l1.72 7.133a2.042 2.042 0 0 1-.389 1.749z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.bbf8c2fb310fe6fafb179f043e5e1d91.svg";
export { ForwardRef as ReactComponent };